import * as miscService from '@/services/misc';
import type { Switches } from '@/services/misc';

const ABTestKey = '__ABTEST__';
let value = window.localStorage.getItem(ABTestKey);

/**
 * 生成ABTest Key
 */
export function genABTestKey() {
  if (!value) {
    try {
      value = String(window.crypto.getRandomValues(new Uint32Array(1))[0]);
    } catch {
      value = String(Math.floor(Math.random() * (1e10 - 1 - 1e9) + 1e9));
    }

    window.localStorage.setItem(ABTestKey, value);
  }

  return value;
}

type SwitchValueTypeWithExtra = SwitchValueType | string | number | boolean | string[];

/**
 * 获取指定实验变量
 */
const switches: Record<string, SwitchValueTypeWithExtra> = {};
let fetcher: Promise<Switches> | null;
export async function fetchABTest<T extends SwitchValueTypeWithExtra>(
  name: string,
  defaultValue: T,
) {
  // 优先读缓存
  if (switches[name] != null) {
    return (switches[name] as T) ?? defaultValue;
  }

  // 不存在则读服务端
  if (switches[name] == null) {
    try {
      // 判断之前的请求是否完成，如果已完成则fetcher为null
      // 由于目前后端的接口会返回所有实验变量，所以这里控制下当发生并发请求的时候只用第一个请求的结果即可
      if (fetcher == null) {
        fetcher = miscService.querySwitches(name);
      }

      const res = await fetcher;
      // 合并到缓存里
      Object.assign(switches, res ?? {});

      return (switches[name] as T) ?? defaultValue;
    } catch {
    } finally {
      fetcher = null;
    }
  }

  // 兜底值
  return defaultValue;
}
